import React from "react";

import { serverUrl } from "../../config";
import { useNavigate } from "react-router";
import { filesystem_root, subdomain } from "../../config";

import GridItem from "../../partials/gridItem";

export default function EventItem(props) {
  const navigate = useNavigate();
  const formatDate = (strDate) => {
    if(!strDate) {
      return {
        weekday: "",
        date: {
          day: "",
          month: "",
        },
      };
    }
    if (strDate !== "") {
      const date = new Date(parseInt(strDate.replace("\n", "").trim()) * 1000);
      const day = date.toLocaleString("en-GB", {
        day: "2-digit",
        timeZone: "Europe/London",
      });
      const month = date.toLocaleString("en-GB", {
        month: "short",
        timeZone: "Europe/London",
      });
      const weekday = date.toLocaleString("en-GB", {
        weekday: "short",
        timeZone: "Europe/London",
      });
      return {
        weekday: weekday.toUpperCase(),
        date: {
          day: day,
          month: month.toUpperCase(),
        },
      };
    } else
      return {
        weekday: "",
        date: {
          day: "",
          month: "",
        },
      };
  };

  let startDate = formatDate(props.item.field_start_date);
  let endDate = formatDate(props.item.field_end_date);

  if (props.creator) {
    return (
      <>
        <GridItem
          xs={12}
          sm={6}
          md={3}
          itemClass="events"
          item={props.item}
          bundle={props.item?.bundle}
          id={props.item?.id}
          title={props.item?.title}
          // field_body={
          //   props.item?.summary ? props.item?.summary : props.item?.body
          // }
          category_label={props.item.category_labels}
          created={props.item?.created}
          hasImg={true}
          imgSrc={`${serverUrl}/${props.item.field_featured_image}`}
          alt={`Poster for event ${props.item.id}`}
          cardActionArea={true}
          creator={props.creator}
          cardActionCallBack={
            props.creator
              ? () => {}
              : () => navigate(`/events/${props.item?.id}`)
          }
          contentType={props.contentType}
          shareEnabled
          route={"events"}
          field_access_token={props.item.access_token}
          sharePrompt={`This is a public link that enables you to share the event with your client, no login required.`}
        ></GridItem>
      </>
    );
  } else {
    const id = props.item?.id;
    // eslint-disable-next-line
    const imgSrc = `${filesystem_root}/${subdomain}/events/${id}/${id}/${props.item.field_featured_image}`;
    return (
      <GridItem
        xs={12}
        md={6}
        itemClass="event"
        bundle={props.item?.bundle}
        cardActionArea={true}
        cardActionCallBack={() => navigate(`/events/${props.item?.nid}`)}
        route="events"
        nid={props.item.nid}
        title={props.item.title}
        category_label={props.item.category_labels}
        hasImg={true}
        imgSrc={`${serverUrl}${props.item.field_featured_image} `}
        event={true}
        textContainerCol={""}
        eventStartDate={startDate}
        eventEndDate={endDate}
        contentType={props.contentType}
        shareEnabled
        field_access_token={props.item.field_access_token}
        sharePrompt={`This is a public link that enables you to share the event with your client, no login required.`}
      />
    );
  }
}
